import { useMemo } from 'react';
import type { Role } from '@hotjar/webapp/features/Activation/OnboardingPage/steps/OrganizationSteps/steps/OrganizationRole';

export interface RoleChoice {
  label: string;
  value: Role;
}

export const useRoleChoices = (): RoleChoice[] => {
  return useMemo(() => {
    return [
      {
        label: 'activation:saml-sso.form.option-data-analyst',
        value: 'data analyst',
      },
      {
        label: 'activation:saml-sso.form.option-consultant',
        value: 'consultant',
      },
      {
        label: 'activation:saml-sso.form.option-digital-marketer',
        value: 'digital marketer',
      },
      {
        label: 'activation:saml-sso.form.option-product-manager',
        value: 'product manager',
      },
      {
        label: 'activation:saml-sso.form.option-ceo',
        value: 'ceo',
      },
      {
        label: 'activation:saml-sso.form.option-product-designer',
        value: 'product designer',
      },
      {
        label: 'activation:saml-sso.form.option-engineer',
        value: 'engineer',
      },
      {
        label: 'activation:saml-sso.form.option-content-designer',
        value: 'content designer',
      },
      {
        label: 'activation:saml-sso.form.option-ux-researcher',
        value: 'ux researcher',
      },
      {
        label: 'activation:saml-sso.form.option-other',
        value: 'other',
      },
    ];
  }, []);
};
